module.exports = __webpack_public_path__ + "img/astral_6.59b81f4f.svg";